import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IMPublication} from '@immanens-com/fidji-api-module';
import {ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-publication-grid',
  templateUrl: './publication-grid.component.html',
  styleUrls: ['./publication-grid.component.scss'],
  encapsulation : ViewEncapsulation.None
})
export class PublicationGridComponent {

  @Input() active = true;
  @Input() publicationList: IMPublication[];
  @Output() publicationSelected = new EventEmitter<IMPublication>();
  constructor() {
  }

  public emitPublication(publication: IMPublication) {
    this.publicationSelected.next(publication);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/publication-list/publication-grid/publication-grid.component.ts